export const headers = {
    initialHeaders: [
        { title: "Nombre del empleado", field: "name", child: null },
        {title: "Tipo de contrato", field: "contract", child: null,},
        { title: "Fecha de creación", field: "creationDate", child: null },
    ]
}